// extracted by mini-css-extract-plugin
module.exports = {"container":"Toast_container__1yVJ5"};